// extracted by mini-css-extract-plugin
export default {"generic-field":"_generic-field_TSinOV"};